import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _BaseCustomSidebarPanel_brand;
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";

/**
 * Base class representing a sidebar section header interface.
 */
let BaseCustomSidebarPanel = (_class = (_BaseCustomSidebarPanel_brand = /*#__PURE__*/new WeakSet(), class BaseCustomSidebarPanel {
  constructor() {
    _classPrivateMethodInitSpec(this, _BaseCustomSidebarPanel_brand);
    _initializerDefineProperty(this, "sections", _descriptor, this);
  }
  /**
   * @returns {boolean} Controls whether the panel is hidden, which means that
   * it will not show up in combined sidebar mode, and its switch button will
   * never show either.
   */
  get hidden() {
    return false;
  }

  /**
   * @returns {string} Identifier for sidebar panel
   */
  get key() {
    _assertClassBrand(_BaseCustomSidebarPanel_brand, this, _notImplemented).call(this);
  }

  /**
   * @returns {string} Text for the switch button. Obsolete when panel is hidden.
   */
  get switchButtonLabel() {
    this.hidden || _assertClassBrand(_BaseCustomSidebarPanel_brand, this, _notImplemented).call(this);
  }

  /**
   * @returns {string} Icon for the switch button. Obsolete when panel is hidden.
   */
  get switchButtonIcon() {
    this.hidden || _assertClassBrand(_BaseCustomSidebarPanel_brand, this, _notImplemented).call(this);
  }

  /**
   * @returns {string} Default path to panel. Obsolete when panel is hidden.
   */
  get switchButtonDefaultUrl() {
    this.hidden || _assertClassBrand(_BaseCustomSidebarPanel_brand, this, _notImplemented).call(this);
  }

  /**
   * @returns {boolean} Controls whether the filter is shown
   */
  get filterable() {
    return false;
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sections", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class);
function _notImplemented() {
  throw "not implemented";
}
export { BaseCustomSidebarPanel as default };